<script>
import { propertyComputed, authComputed } from '@state/helpers'

export default {
  props: {
    dropdown: { type: Object, required: true },
  },
  data: () => ({
    form: {
      title: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      countryId: '',
      joinMember: false,
      password: null,
    },
    confirmEmail: '',
    confirmPassword: '',
  }),
  computed: {
    ...propertyComputed,
    ...authComputed,
  },
  watch: {
    'form.joinMember'(val) {
      if (!val) {
        this.form.password = null
        this.confirmPassword = null
      }
    },
    loggedIn(val) {
      if (val) this.assignForm()
    },
  },
  created() {
    if (this.loggedIn) this.assignForm()
  },
  methods: {
    assignForm() {
      this.form.title = this.currentUser.title
      this.form.firstName = this.currentUser.firstName
      this.form.lastName = this.currentUser.lastName
      this.form.email = this.currentUser.email
      this.form.countryId = this.currentUser.country.id
    },
  },
}
</script>

<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-2/12">
      <BaseSelect
        v-model="form.title"
        class="md:w-1/3 lg:w-full"
        label="Title"
        rules="required"
        :items="dropdown.titles"
      />
      <!-- title -->
    </div>
    <BaseInput
      v-model="form.firstName"
      class="md:w-1/2 lg:w-5/12"
      label="First name"
      rules="required|min:3"
    />
    <!-- first name -->

    <BaseInput
      v-model="form.lastName"
      class="md:w-1/2 lg:w-5/12"
      label="Last name"
      rules="required|min:3"
    />
    <!-- last name -->

    <BaseInput
      v-model="form.email"
      class="md:w-1/2"
      label="Email"
      type="email"
      rules="required|email"
    />
    <!-- email -->

    <BaseInput
      v-if="!loggedIn"
      v-model="confirmEmail"
      class="md:w-1/2"
      label="Confirm email"
      type="email"
      rules="required|confirmed:email"
    />

    <BaseInput
      v-model="form.phone"
      class="md:w-1/2"
      label="Phone number (optional)"
      type="tel"
    />
    <!-- email -->

    <BaseSelect
      v-model="form.countryId"
      class="md:w-1/2"
      label="Country"
      rules="required"
      :items="dropdown.countries"
    />
    <!-- country -->
    <BaseCheckbox
      v-if="!loggedIn"
      id="member-join"
      v-model="form.joinMember"
      :label="`I would like to join ${property.name} members`"
      class="px-3 mb-6 w-full"
    />
    <template v-if="form.joinMember && !loggedIn">
      <BaseInput
        v-model="form.password"
        class="md:w-1/2"
        label="Password"
        type="password"
        rules="required|min:8"
      />
      <BaseInput
        v-model="confirmPassword"
        class="md:w-1/2"
        label="Confirm password"
        type="password"
        rules="required|confirmed:password"
      />
    </template>
  </div>
</template>
